import React, { Component } from 'react';
import axios from 'axios';
import { Row, Col, ProgressBar } from 'react-bootstrap';

import DocumentField from './DocumentField';


class RequiredDocForm extends Component {

    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            file: null,
            updating: false,
            uploadProgress:0,
            errors: []
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.downloadExample = this.downloadExample.bind(this);
        this.validateFile = this.validateFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateUploadFileProgress = this.updateUploadFileProgress.bind(this);
    }

    componentDidMount() {
        const { subscriberId } = this.props;
        this._isMounted = true;

        const ROOT_URL = process.env.API_URL;
        let url = `${ROOT_URL}/leads/documents/${this.props.documentType}`;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };

        if (subscriberId) {
            url = url + `/subscriber/${subscriberId}`;
        }
        if (this._isMounted) {
            axios.get(url, config)
            .then((response)=> {
                this.setState({
                    isLoaded: true
                });
                this.props.onUpdateStatus(this.props.documentType)
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    validateFile(){
        let errors = [];
        if(!this.props.fileTypes.includes(this.state.file.type)){
            errors.push('Formato de archivo no válido.');
        }
        if(this.state.file.size > this.props.maxSize){
            errors.push('El tamaño del archivo supera el valor permitido.');
        }
        if(errors.length > 0){
            this.setState({...this.state, errors: errors});
            return false;
        }
        return true;
    }

    updateUploadFileProgress(progress) {
        const { total, loaded } = progress;

        this.setState({
            uploadProgress: total/loaded,
        });
    }

    handleSubmit(event){
        const { subscriberId } = this.props;

        event.preventDefault();

        if(!this.validateFile()){
            return
        }

        this.setState({...this.state, updating: true});

        const ROOT_URL = process.env.API_URL;
        let url = `${ROOT_URL}/leads/documents/${this.props.documentType}`;
        const config = {
            headers:
                {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                    'Content-Type': 'multipart/form-data'
                },
            onUploadProgress: this.updateUploadFileProgress,
        };

        const formData = new FormData();

        if (subscriberId) {
            url = url + `/subscriber/${subscriberId}`;
        }

        formData.append('file', this.state.file);
        axios.post(url, formData, config)
        .then((response)=> {
            this.setState({
                isLoaded: true
            });
            this.props.onUpdateStatus(this.props.documentType)
        });
    }

    handleChange(file){
        this.setState({
            ...this.state,
            file: file,
            errors:[],
        })
    }
    
    downloadExample(event) {
        const { documentType } = this.props;
        const ROOT_URL = process.env.API_URL; 
        const config = {
          headers:
            {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };
        event.preventDefault();
        const json = JSON.stringify({ slug: documentType });
        axios.post(`${ROOT_URL}/subscribers/document_example` , json ,config).then((response)=> {
            const contentType = response.data.mime_type;
            const base64Data = response.data.blob_file;
            const fileName = response.data.name;
            const extension = response.data.extension;
            this.downloadBase64File(contentType, base64Data, fileName + '.' +extension);
        })
    }
    
    downloadBase64File(contentType, base64Data, fileName) {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
   }

    render() {
        const { updating, file, isLoaded, errors, uploadProgress } = {...this.state}
        const field = <DocumentField onChange={this.handleChange} updating={updating}/>


        const errorComponent = errors.map(error => {
             return (<Row className="terms_row">
                        <Col className="col-lg-offset-7 col-md-offset-7 col-xs-offset-7" xs={5} md={5} lg={5}>
                            <div className="help-block" style={{color:'#c00'}}>{error}</div>
                        </Col>
                     </Row>);
         });

        const progressUpload = (
            <Row>
                <Col className="terms_col col-md-offset-3 col-xs-offset-3 col-lg-offset-3" xs={6} md={6} lg={6}>
                    <ProgressBar now={uploadProgress}/>
                </Col>
            </Row>
        );
        const buttonExample = (
            <div className='text-center'>
                    <button
                      onClick={this.downloadExample}          
                      className={'btn save-step-button'}>
                      <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/download.png`)}/>
                      Ejemplo
                    </button> 
                </div>
        )
        const documentForm = (
            <div style={{padding: '10px 0px 10px 0px'}}>
            <Row className="terms_row">
                <Col className="pd-vcenter text-center" xs={12} md={12} lg={12}>
                    {this.props.example ? buttonExample : null}
                    </Col>
            </Row>
            <Row>
                <Col className="pd-vcenter text-center" xs={12} md={12} lg={12}>
                    <span>{this.props.label}</span>
                    {!this.props.required ? (<span><p>(Si corresponde)</p></span>) : ''}
                </Col>
            </Row>
            <Row className="terms_row">
                <Col className="pd-vcenter text-center" xs={12} md={12} lg={12}>
                    {field}
                </Col>
                {updating && progressUpload}
                <Col className="terms_col pd-vcenter text-center" xs={12} md={12} lg={12}>
                    <button className={'btn btn-default'} disabled={(updating || !file)} onClick={this.handleSubmit}><span>{updating ? 'Enviando' : 'Enviar'}</span></button>
                </Col>
            </Row>
            {errors ? errorComponent : ''}
            </div>);

        const loadedComponent = (
            <div style={{padding: '10px 0px 10px 0px'}}>
            <Row className="terms_row">
                <Col className="terms_col terms_checkbox pd-vcenter" xs={12} md={12} lg={12}>
                <Row className="terms_row">
                    <Col className="terms_col pd-vcenter text-center" xs={12} md={12} lg={12}>
                        <span>{this.props.label}</span>
                    </Col>
                </Row>
                </Col>
                <Col className="terms_col pd-vcenter text-center" xs={12} md={12} lg={12}>
                    <button className={'btn btn-success'} disabled={true}><span>Enviado</span></button>
                </Col>
            </Row>
            {errors ? errorComponent : ''}
            </div>);

        const component = isLoaded ? loadedComponent : documentForm

        return component;
    }
}


export default RequiredDocForm;


/** WEBPACK FOOTER **
 ** ./src/components/RequiredDocForm.js
 **/